import { SignalRHubService } from './SignalRHubService';
import type { SignalRConfig } from './types';

// Create SignalR configuration
const signalRConfig: SignalRConfig = {
  baseUrl: import.meta.env.VITE_SIGNALR_BASE_URL,
  hubName: 'wlc-hub',
};

// Create singleton instance
export const signalRService = new SignalRHubService(signalRConfig);
